import moment from 'moment';

import type { TicketDistributionData } from '../../types';

export const generateInitialFormValues = (
  ticketDistributionData: TicketDistributionData | undefined
) => {
  if (!ticketDistributionData) {
    return undefined;
  }
  return {
    ...ticketDistributionData,
    issueDate: moment(ticketDistributionData.issueDate),
    startDate: moment(ticketDistributionData.startDate),
    endDate: moment(ticketDistributionData.endDate),
  };
};
